import { Skeleton } from "@material-ui/lab";
import { NonNullableOrganisationState } from "../../redux/state";
import { ScrollableAreaTabs as CoreScrollableAreaTabs } from "@ofqual/portal-components/components/ScrollableAreaTabs";
import { OrganisationsActivityFeed } from "./OrganisationsActivityFeed";
import {
  LinkedRecords,
  LinkedRecordType,
} from "@ofqual/portal-linked-records/linked-records";

export const OrgScrollableAreaTabs: React.FC<{
  orgState: NonNullableOrganisationState | null;
  isOfqualUser: boolean;
}> = ({ orgState, isOfqualUser }) =>
  orgState ? (
    <CoreScrollableAreaTabs
      twelfths={4}
      dataTest="activity-tabs"
      tabs={
        isOfqualUser
          ? [
              {
                label: "Activity",
                content: (
                  <OrganisationsActivityFeed organisation={orgState.org} />
                ),
              },
              {
                label: "Linked Records",
                content: (
                  <LinkedRecords
                    entityReferenceId={orgState.org?.itemId?.toString()}
                    entityTitle={orgState.org?.name}
                    entityLinkedRecordType={LinkedRecordType.organisation}
                  />
                ),
                tabTypeId: "linkedRecords",
                dataTest: "linked-record-tab",
              },
            ]
          : [
              {
                label: "Activity",
                content: (
                  <OrganisationsActivityFeed organisation={orgState.org} />
                ),
              },
            ]
      }
    ></CoreScrollableAreaTabs>
  ) : (
    <>
      <Skeleton variant="text" height={60} />
      <br />
      <Skeleton variant="text" height={60} />
      <Skeleton variant="text" height={60} />
      <br />
      <Skeleton variant="rect" height={118} />
      <br />
      <Skeleton variant="text" height={60} />
      <br />
      <Skeleton variant="text" height={60} />
      <Skeleton variant="text" height={60} />
      <br />
      <Skeleton variant="rect" height={118} />
    </>
  );
